import { Box, Button, Grid, IconButton, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import AdminNavbar from "../components/nav-bar";
import GridCardItem from "../components/grid-card-item";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import ToastMessage from "../components/toast-message";
import axios from "axios";

const items = [
    { title: 'Pending Articles Review', url: '/articles?status=0', newTab: false },
    // { title: 'Pending Peer Review Applications', url: '/peer-reviewers?status=0', newTab: false },
    // { title: 'Pending Editorial Board Applications', url: '/editorial-board?status=0', newTab: false },
    // { title: 'Access Blog', url: 'https://blog.wajls.com/wp-admin/index.php', newTab: true },
    { title: 'Access Email', url: 'https://mail.hostinger.com/?clearSession=true&_user=info@wajls.com', newTab: true },
];

function Dashboard() {
    const admin = JSON.parse(localStorage.getItem('admin'));
    
    const [blogCred, setBlogCred] = useState({
        username: 'admin@wajls.com',
        password: ')irXFLcjus(&DGiwtV8i^9oe'
    });

    const [emailCred, setEmailCred] = useState({
        username: 'info@wajls.com',
        password: 'Wajls##123'
    });

    const [passwords, setPasswords] = useState({
        curP: '',
        newP: ''
    });
    const [showPassword, setShowPassword] = useState({
        '1': false,
        '2': false,
        '3': false
    });

    const [status, setStatus] = useState({
        type: 0,
        message: ''
    });

    const clearToastMessge = () => {
        setStatus({
            type: 0,
            message: ''
        });
    };

    const togglePasswordVisibility = (key) => {
        setShowPassword((prev) => ({
          ...prev,
          [key]: !prev[key]
        }));
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;

        setPasswords((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };


    const changePassword = async () => {
        if (!passwords.curP || !passwords.newP) {
            setStatus({
                type: 0,
                message: 'please fill in all fields'
            });
            return;
        };


        try {
            const payload = { username: admin.username, password: passwords.curP, newPassword: passwords.newP};

            const response = await axios.post('https://api.wajls.com/admin/v1/change_password.php', payload);
    
            setStatus({
                type: response.data.success ? 1 : 0,
                message: response.data.message
            });

        } catch (error) {
            console.error(error);
        }
    };
      
    return (
        <Box sx={{ backgroundColor: 'grey.100', minHeight: '100vh' }}>
            <AdminNavbar/>
            <Box
                sx={{
                    margin: 'auto',
                    maxWidth: 'lg',
                    padding: 1
                }}
            >

                <Typography variant="h5"
                    sx={{
                        width: 'fit-content',
                        fontFamily: '',
                        borderBottom: '2px solid rgb(10, 197, 35)',
                        borderBottomLeftRadius: '5px',
                        paddingRight: '50px'
                    }}
                >
                    Quick Actions
                </Typography>

                <Grid container spacing={2} sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
                    {items.map((item, index) => (
                        <Grid key={index} size={{ xs: 12, md:4}}>
                            <GridCardItem title={item.title} url={item.url} newTab={item.newTab}/>
                        </Grid>
                    ))};
                </Grid>
                
                <Typography variant="h5"
                    sx={{
                        width: 'fit-content',
                        fontFamily: '',
                        borderBottom: '2px solid rgb(10, 197, 35)',
                        borderBottomLeftRadius: '5px',
                        paddingRight: '50px',
                        marginTop: 5
                    }}
                >
                    Account and Settings
                </Typography>

                
                <Grid container spacing={2} sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Paper
                            sx={{
                                padding: 2,
                                backgroundColor: 'white'
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    width: 'fit-content',
                                    borderBottom: '2px solid rgb(236, 140, 51)',
                                    paddingRight: '30px',
                                    borderBottomLeftRadius: '5px'
                                }}
                            >
                                Email Credentials
                            </Typography>

                            <Box sx={{ padding: 2 }}>
                                <TextField
                                    fullWidth
                                    disabled
                                    value={emailCred.username}
                                    sx={{ mb: 2 }}
                                />

                                <TextField
                                    fullWidth
                                    type={showPassword['2'] ? "text" : "password"}
                                    disabled
                                    value={emailCred.password}
                                    label="Password"
                                    InputProps={{
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => togglePasswordVisibility('2')} edge="end">
                                            {showPassword['2'] ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                        ),
                                    }}
                                />

                                
                            </Box>

                        </Paper>
                    </Grid>

                    {/* <Grid size={{ xs: 12, md: 4 }}>
                        <Paper
                            sx={{
                                padding: 2,
                                backgroundColor: 'white'
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    width: 'fit-content',
                                    borderBottom: '2px solid rgb(236, 140, 51)',
                                    paddingRight: '30px',
                                    borderBottomLeftRadius: '5px'
                                }}
                            >
                                Blog Credentials
                            </Typography>

                            <Box sx={{ padding: 2 }}>
                                <TextField
                                    fullWidth
                                    disabled
                                    value={blogCred.username}
                                    sx={{ mb: 2 }}
                                />

                                <TextField
                                    fullWidth
                                    type={showPassword['1'] ? "text" : "password"}
                                    disabled
                                    value={blogCred.password}
                                    label="Password"
                                    InputProps={{
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => togglePasswordVisibility('1')} edge="end">
                                            {showPassword['1'] ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                        ),
                                    }}
                                />

                                
                            </Box>

                        </Paper>
                    </Grid> */}

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Paper
                            sx={{
                                padding: 2,
                                backgroundColor: 'white'
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    width: 'fit-content',
                                    borderBottom: '2px solid rgb(236, 140, 51)',
                                    paddingRight: '30px',
                                    borderBottomLeftRadius: '5px'
                                }}
                            >
                                Update Admin Password
                            </Typography>

                            <Box sx={{ padding: 2 }}>
                                <TextField
                                    fullWidth
                                    type="password"
                                    label="Current Password"
                                    name="curP"
                                    value={passwords.curP}
                                    onChange={handlePasswordChange}
                                    sx={{ mb: 2 }}
                                />

                                <TextField
                                    fullWidth
                                    type={showPassword['3'] ? "text" : "password"}
                                    name="newP"
                                    value={passwords.newP}
                                    onChange={handlePasswordChange}
                                    label="New Password"
                                    InputProps={{
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => togglePasswordVisibility('3')} edge="end">
                                            {showPassword['3'] ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                        ),
                                    }}
                                    sx={{ mb: 2 }}
                                />
                                
                                <Button variant="contained" fullWidth onClick={changePassword}>Update</Button>
                            </Box>

                        </Paper>
                    </Grid>
                </Grid>
                      
            </Box>
            {status.message && <ToastMessage type={status.type} message={status.message} onClose={clearToastMessge}/>}
        </Box>
    );
};
export default Dashboard;